import logoImg from '@assets/images/logo.svg';
import { IconOutlineLogout } from '@components/icons/outline';
import { Button } from '@components/ui';
import { Link } from 'react-router-dom';

export const NotFound = () => {
  return (
    <main className="p-8 text-center ">
      <div className="py-2">
        <img
          className="mx-auto block h-10 xl:h-12"
          src={logoImg}
          alt="logo"
        />
      </div>

      <div className="mt-16 text-8xl font-extrabold xl:mt-32 xl:text-9xl">
        <span>4</span>
        <span className="text-primary/50">0</span>
        <span>4</span>
      </div>

      <h1 className="mt-4 text-3xl font-extralight">
        Sorry, it looks like the page get lost
      </h1>

      <div className="mt-8">
        <Button
          as={Link}
          to="/"
          size="lg"
          className="!font-bold"
          prependIcon={IconOutlineLogout}
          rounded
        >
          Go back Home
        </Button>
      </div>
    </main>
  );
};
